import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	forgeRetryButton: {
		id: 'forge-field-base.form.field-message.field-dispatch-button.forge-retry-button',
		defaultMessage: 'Try again?',
		description: 'Message shown on button to retry action of retriving Forge custom field value.',
	},
});
